import { render, staticRenderFns } from "./update_record detail.vue?vue&type=template&id=744f1851&scoped=true&"
import script from "./update_record detail.vue?vue&type=script&lang=js&"
export * from "./update_record detail.vue?vue&type=script&lang=js&"
import style0 from "./update_record detail.vue?vue&type=style&index=0&id=744f1851&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "744f1851",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\00_GIT\\hotel\\hotel-front-admin\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('744f1851')) {
      api.createRecord('744f1851', component.options)
    } else {
      api.reload('744f1851', component.options)
    }
    module.hot.accept("./update_record detail.vue?vue&type=template&id=744f1851&scoped=true&", function () {
      api.rerender('744f1851', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/net_bar/device_price/update_record detail.vue"
export default component.exports